import dayjs from "dayjs";
import timezone from "dayjs/plugin/timezone";
import utc from "dayjs/plugin/utc";

import store from "../store";
import * as colors from "../styles/colors";

dayjs.extend(utc);
dayjs.extend(timezone);

const getPropertyPatrols = ({
  property,
  darsByPropertyId = store.getState().dars.byPropertyId,
}) => {
  let patrols = null;
  let overduePatrols = null;
  let millisecondsSinceLatestPatrolWindowEnded = null;
  const nowMoment = dayjs();
  const timezoneAdjustedMoment = nowMoment
    .tz(property.place.timezone)
    .second(0)
    .millisecond(0);
  for (const patrolWindow of property.patrolWindows) {
    let patrolWindowStartMoment = timezoneAdjustedMoment
      .hour(Math.floor(patrolWindow.minsToStart / 60))
      .minute(patrolWindow.minsToStart % 60);
    let patrolWindowEndMoment =
      patrolWindow.minsToEnd <= patrolWindow.minsToStart
        ? timezoneAdjustedMoment
            .add(1, "day")
            .hour(Math.floor(patrolWindow.minsToEnd / 60))
            .minute(patrolWindow.minsToEnd % 60)
        : timezoneAdjustedMoment
            .hour(Math.floor(patrolWindow.minsToEnd / 60))
            .minute(patrolWindow.minsToEnd % 60);
    if (patrolWindowStartMoment.valueOf() > nowMoment.valueOf()) {
      // We have no interest in future patrol windows. Wind the clock back 24 hours for any patrol window in the future.
      patrolWindowStartMoment = patrolWindowStartMoment.subtract(1, "day");
      patrolWindowEndMoment = patrolWindowEndMoment.subtract(1, "day");
    }
    if (
      nowMoment.valueOf() >= patrolWindowStartMoment.valueOf() &&
      nowMoment.valueOf() < patrolWindowEndMoment.valueOf()
    ) {
      const patrolCount = darsByPropertyId[property.propertyId]
        ? Object.values(darsByPropertyId[property.propertyId].byId).filter(
            (dar) => {
              return (
                patrolWindowStartMoment.valueOf() <= dar.startTime &&
                dar.startTime < patrolWindowEndMoment.valueOf()
              );
            }
          ).length
        : 0;

      if (patrolCount < patrolWindow.darsRequired) {
        const patrolWindowMinutes = patrolWindowEndMoment.diff(
          patrolWindowStartMoment,
          "minute"
        );
        const minutesRemaining = patrolWindowEndMoment.diff(
          nowMoment,
          "minutes"
        );
        patrols = {
          reason: "Requires patrolling",
          color: colors.KONTRA_BLUE,
          zIndex: property.cardinal ? 97 : 94,
          count: `${patrolCount} of ${patrolWindow.darsRequired}`,
          timeRemainingPercentage: Math.round(
            (minutesRemaining / patrolWindowMinutes) * 100
          ),
        };
      } else {
        // If we are in an active window and all patrols have been done then nothing else needs to be done. Exit
        // execution!
        return null;
      }
    } else {
      const millisecondsSincePatrolWindowEnd = nowMoment.diff(
        patrolWindowEndMoment
      );
      if (
        millisecondsSinceLatestPatrolWindowEnded === null ||
        millisecondsSinceLatestPatrolWindowEnded >
          millisecondsSincePatrolWindowEnd
      ) {
        millisecondsSinceLatestPatrolWindowEnded = millisecondsSincePatrolWindowEnd;
        const patrolCount = darsByPropertyId[property.propertyId]
          ? Object.values(darsByPropertyId[property.propertyId].byId).filter(
              (dar) => patrolWindowStartMoment.valueOf() <= dar.startTime
            ).length
          : 0;
        if (patrolCount < patrolWindow.darsRequired) {
          overduePatrols = {
            reason: "Patrols overdue",
            color: colors.markers.property.MEDIUM_PRIORITY,
            zIndex: property.cardinal ? 98 : 95,
            count: `${patrolCount} of ${patrolWindow.darsRequired}`,
          };
        } else {
          overduePatrols = null;
        }
      }
    }
    if (patrols) {
      break;
    }
  }
  return patrols ? patrols : overduePatrols;
};

export default getPropertyPatrols;
